import { useContext } from "react";
import KeyMapperContext from "views/components/visualizations/KeyMapperContext";
const useMapKeys = () => useContext(KeyMapperContext);
export default useMapKeys;
